import React, { useState, useRef } from 'react'
import { Radio, RadioGroup, Dialog, DialogBackdrop, DialogPanel, DialogTitle, Transition } from '@headlessui/react'
import {
    CheckIcon,
    TrashIcon,
    CreditCardIcon,
    ArrowLeftIcon,
    InformationCircleIcon,
    PrinterIcon,
    InboxIcon,
    ChatBubbleLeftRightIcon,
} from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import bookingConfirm from '../../../assets/images/booking_confirm.png'
import { useNavigate, useLocation } from 'react-router-dom'
import { SEND_TICKET_TO_EMAIL } from '../../../graphql/booking/mutations'
import { useMutation } from '@apollo/client'
import { ErrorDialog, SuccessDialog } from 'components/custom/ResponseDialog'
import { BoatBookingImage } from 'components/icons'
import { customTimeFormat } from 'utils/common'
import { QRCodeCanvas } from 'qrcode.react'
import { useEffect } from 'react'
import TicketActions from 'components/custom/TicketActions'

export default function BoatBookingConformation({
    bookingData: propsBookingData,
    isManagePage = false,
    open,
    onClose,
}) {
    const qrCodeRef = useRef()
    const { i18n, t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const { bookingData: stateBookingData } = location.state || {}
    const bookingData = propsBookingData || stateBookingData
    const [submitLoading, setSubmitLoading] = useState(false)
    const [showSucDialog, setShowSucDialog] = useState(false)
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [dialogMessage, setDialogMessage] = useState('')
    const [email, setEmail] = useState('')

    const [sendBookingTicket, { loading: sendLoading }] = useMutation(SEND_TICKET_TO_EMAIL, {
        onCompleted: data => {
            if (data?.sendBookingTicket.code === '200' && data?.sendBookingTicket.success === true) {
                setShowSucDialog(true)
                setDialogMessage(data?.sendBookingTicket.message)
                // timeout to close the dialog
                setTimeout(() => {
                    setShowSucDialog(false)
                }, 3000)
            } else {
                setDialogMessage(data?.sendBookingTicket.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            setDialogMessage(t('Something went wrong, please try again later'))
            setShowErrDialog(true)
        },
    })
    const handleNavigation = () => {
        navigate('/boat-booking')
    }
    const handleClose = () => {
        setShowErrDialog(false)
        onClose()
        navigate('/boat-booking')
    }
    useEffect(() => {
        const qrCodeCanvas = document.getElementById('qrcode')
        if (qrCodeCanvas) {
            const canvas = qrCodeCanvas.querySelector('canvas')
            if (canvas) {
                const qrCodeDataUrl = canvas.toDataURL()
                canvas.setAttribute('src', qrCodeDataUrl)
            }
        }
    }, [bookingData])

    const handleSendWhatsapp = mobile => {
        // Implement your mobile sending logic here
    }
    const handleDialogClose = () => {
        setShowSucDialog(false)
        setShowErrDialog(false)
    }

    const GoDetailsPage = () => {
        navigate(`/manage-boat-booking/details/${bookingData.booking_id}/${bookingData.trip_segments[0].travel_date}`, {
            state: {  },
        })
    }

    return (
        <Transition.Root show={open} as={React.Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                onClose={() => {}} // This prevents closing on backdrop click
                static
                unmount={false}
            >
                <Transition.Child
                    as={React.Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <DialogBackdrop static className="fixed inset-0 bg-gray-900 backdrop-blur-md bg-opacity-75" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={React.Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div id="booking_section" className={`flow-root bg-white`}>
                                        <div className="mx-auto max-w-7xl px-4 lg:px-8 mt-5">
                                            <div>
                                                <div
                                                    id="book_img"
                                                    className="mx-auto flex h-25 w-[130px] items-center justify-center rounded-full bg-green-100"
                                                >
                                                    <img
                                                        src={bookingConfirm}
                                                        className="w-full me-2"
                                                        alt="Booking Confirmation"
                                                    />
                                                </div>

                                                <div className="mt-3 text-center sm:mt-5">
                                                    <p className="text-xl font-bold leading-6 text-gray-900 pb-2">
                                                        {t('Booking success')}
                                                    </p>
                                                    <div className="mt-0">
                                                        <p className="text-md text-gray-900">
                                                            {t('Booking Ref')} : {bookingData?.booking_code}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex border-t border-slate-200 pt-6 py-4 items-center justify-center mx-auto gap-2 mt-4">
                                                    <button
                                                        type="button"
                                                        onClick={GoDetailsPage}
                                                        className="flex items-center justify-center w-full max-w-sm rounded-md bg-primary text-white px-3 py-3 text-sm font-semibold"
                                                    >
                                                        {t('View Booking Info')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </DialogPanel>
                        </Transition.Child>
                    </div>
                </div>

                {showErrDialog && (
                    <ErrorDialog status={true} title="Error" message={dialogMessage} onClose={handleDialogClose} />
                )}
                {showSucDialog && (
                    <SuccessDialog status={true} title="Success" message={dialogMessage} onClose={handleDialogClose} />
                )}
                {sendLoading && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
                    </div>
                )}
            </Dialog>
        </Transition.Root>
    )
}
